<template>
  <Day day="08.12.2022">
    <div slot="page-content">
      <h1 class="headline mb-5 align-center px-5">
        Indulhat a bulika?
      </h1>

      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header> Fények bekapcsolva, a basszus dübörög, a textil meg vasárnapig felesleges!
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-img style="margin: 0 auto" max-width="300" src="../../assets/dec8.jpg"></v-img>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </Day>
</template>
  
<script>
import Day from "@/views/days/Day.vue";

export default {
  name: "Day08",
  components: {
    Day,
  },
  mounted() {
    document.body.classList.add("party");
  },
  destroyed() {
    document.body.classList.remove("party");
  },
};
</script>
  

<style lang="scss">
.italic {
  font-style: italic;
}

p {
  font-size: 1.3em;
  line-height: 1.8;
}
</style>